<template lang="pug">
.send-message-read-families-modal
  b-modal(v-model="_value" size="xl" no-close-on-backdrop no-close-on-esc)
    template(#modal-header="{ cancel }")
      .send-message-read-families-modal-header(style="width:100%;")
        .d-flex.justify-content-end.flex-fill
          button.btn(@click="onDownload" type="button") ダウンロード
      button.close(type="button" @click="cancel") ×

    .send-message-read-families-modal-table
      .thead
        .header-line
          .th.room-name(v-if="showRoomName") 部屋名
          .th.redident-name {{ residentNameColumnName }}
          .th.family-name 家族ユーザー名
          .th.position 役割
          .th.tel 電話番号
          .th.read-datetime(v-if="showReadDatetime") 既読日時
      .tbody
        .body-line(v-for="family in families")
          .td.room-name(v-if="showRoomName") {{ family.residentRoomName }}
          .td.redident-name {{ family.residentName }}
          .td.family-name {{ family.familyName }}
          .td.position(v-if="family.familyPosition") {{ family.familyPosition }}
          .td.position(v-else) 未設定
          .td.tel {{ family.tel ? family.tel : family.familyTel }}
          .td.read-datetime(v-if="showReadDatetime")
            span(v-if="family.readDatetime") {{ convertDatetime(family.readDatetime) }}

    template(#modal-footer="{ ok }")
      b-button.btn.modal-ok-btn(@click="ok") 閉じる
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { SendMessageReadFamilyModel } from "@/commons/services/SendMessageReadFamilies";

/**
 * ### 家族詳細表示モーダル
 */
@Component
export default class SendMessageReadFamiliesModal extends Vue {
  /** 表示可否 */
  @Prop({ required: true })
  value!: boolean;

  /** 表示対象の家族 */
  @Prop({ required: true })
  families!: Array<SendMessageReadFamilyModel>;

  @Prop({ default: true })
  showRoomName!: boolean;

  @Prop({ default: "利用者名" })
  residentNameColumnName!: string;

  @Prop()
  csvTypeName!: string;

  @Prop()
  sendMessageTitle!: string;

  @Prop()
  showReadDatetime!: boolean;

  get _value(): boolean {
    return this.value;
  }

  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  public ok(): void {
    this.$emit("ok");
    return;
  }

  /**
   * ### PDFダウンロードボタン押下イベント
   */
  public async onDownload(): Promise<void> {
    const csv: string = this.createCsv(this.families);
    this.downloadCsv(csv, `HitomeQコネクト-メッセージ送信-${this.sendMessageTitle}-${this.csvTypeName}.csv`);
    return;
  }

  /**
   * ### イベント申込のCSVを作成する
   */
  public createCsv(families: Array<SendMessageReadFamilyModel>): string {
    let csv: string[] = [];
    if (this.showRoomName) {
      csv.push("\ufeff" + `部屋名,${this.residentNameColumnName},家族ユーザー名,役割,電話番号`);
    } else {
      csv.push("\ufeff" + `${this.residentNameColumnName},家族ユーザー名,役割,電話番号`);
    }

    for (const item of families) {
      const room: string = this.showRoomName ? item.residentRoomName : "";
      const residentName: string = item.residentName;
      const familyName: string = item.familyName;
      const familyPosition: string = item.familyPosition ? item.familyPosition : "未設定";
      const familyTel: string = item.familyTel;

      if (this.showRoomName) {
        csv.push(`${room},${residentName},${familyName},${familyPosition},="${familyTel}"`);
      } else {
        csv.push(`${residentName},${familyName},${familyPosition},="${familyTel}"`);
      }
    }

    return csv.join("\n");
  }

  /**
   * ### CSVファイルをダウンロードさせる
   *
   * - CSVの内容からblobファイルを作成する
   * - blobファイルの種別はtext/csv
   * - a要素を作ってそれを疑似的にクリックさせることでダウンロードさせる
   */
  public downloadCsv(csv: string, fileName: string): void {
    const blob: Blob = new Blob([csv], { type: "text/csv" });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    return;
  }

  /**
   * ### 日付を文字列に変換する
   */
  public convertDatetime(datetime: number): string {
    return this.$dateUtil.convertNumberToString(datetime, "yyyy年mm月dd日 hh:MM");
  }
}
</script>
